import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { FormDatePicker } from "go-form/components/FormDatePicker";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { InvoiceApi, InvoiceCalculationType } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<InvoiceApi>;
}

const InvoiceFormBasicInfo = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
		control,
	} = form;
	const calculationTypeOptions = [InvoiceCalculationType.GROSS, InvoiceCalculationType.NET].map((option) => ({
		value: option,
		label: t(`enums.invoices.calculation_type.${option}`),
	}));

	return (
		<fieldset className="form-group">
			<h5>{t("common.word.basic_info")}</h5>
			<div className="row">
				<div className="col-lg-10">
					<div className="row">
						<div className="col-md-6">
							<FormDatePicker
								label={t("modules.invoice.field.issued_at.title")}
								control={control}
								name="dates.issue_date"
								timePicker={false}
								errors={errors}
								allowClear={false}
							/>
						</div>
						<div className="col-md-6">
							<FormInput
								label={t("modules.invoice.field.place_of_issue.title")}
								register={register}
								name="place_of_issue"
								errors={errors}
							/>
						</div>
						<div className="col-md-6">
							<FormInput
								label={t("modules.invoice.field.issuer_person_name.title")}
								register={register}
								name="issuer_person_name"
								errors={errors}
							/>
						</div>
						<div className="col-md-6">
							<FormInput
								label={t("common.word.comment.title")}
								register={register}
								name="notes"
								errors={errors}
							/>
						</div>
						<div className="col-md-6">
							<FormSelectGroup
								label={t("modules.invoice.field.invoice_type.title")}
								control={control}
								name="calculation_type"
								errors={errors}
								options={calculationTypeOptions}
							/>
						</div>
						<div className="col-md-6">
							<FormDatePicker
								label={t("modules.invoice.field.sale_date.title")}
								control={control}
								name="dates.sale_date"
								errors={errors}
							/>
						</div>
						<div className="col-md-6">
							<FormDatePicker
								label={t("modules.invoice.field.pay_date.title")}
								control={control}
								name="dates.pay_date"
								errors={errors}
							/>
						</div>
					</div>
				</div>
			</div>
		</fieldset>
	);
};

export default InvoiceFormBasicInfo;
